var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBusinessToConsumerPlan = function SvgBusinessToConsumerPlan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6367 42.111C45.6367 44.2653 46.4925 46.3314 48.0159 47.8547C49.5392 49.3781 51.6053 50.2339 53.7596 50.2339C55.914 50.2339 57.9801 49.3781 59.5034 47.8547C61.0267 46.3314 61.8825 44.2653 61.8825 42.111C61.8825 39.9566 61.0267 37.8905 59.5034 36.3672C57.9801 34.8438 55.914 33.988 53.7596 33.988C51.6053 33.988 49.5392 34.8438 48.0159 36.3672C46.4925 37.8905 45.6367 39.9566 45.6367 42.111Z",
    stroke: "#152A58",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8304 66.4795C67.342 63.0962 65.6509 60.0021 63.0668 57.7643C60.4827 55.5265 57.1788 54.2947 53.7604 54.2947C50.342 54.2947 47.0381 55.5265 44.4541 57.7643C41.87 60.0021 40.1788 63.0962 39.6904 66.4795H67.8304Z",
    stroke: "#152A58",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14451 9.59863H32.2787C32.2787 9.59863 34.2533 9.59863 34.2533 11.5732V28.7699C34.2533 28.7699 34.2533 30.7445 32.2787 30.7445H4.14451C4.14451 30.7445 2.16992 30.7445 2.16992 28.7699V11.5732C2.16992 11.5732 2.16992 9.59863 4.14451 9.59863Z",
    stroke: "#152A58",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9375 9.59883L12.8863 5.5155C13.3548 4.83049 13.9998 4.28484 14.753 3.93623C15.5062 3.58762 16.3395 3.44902 17.165 3.53508H20.0175C20.8433 3.44943 21.677 3.58819 22.4306 3.93674C23.1841 4.28529 23.8297 4.83071 24.2992 5.5155L27.2479 9.59883",
    stroke: "#152A58",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91699 20.4167L14.5837 20.4167",
    stroke: "#152A58",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 20.4167H33.5417",
    stroke: "#152A58",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.097 16.8438H20.3291C20.3291 16.8438 21.7874 16.8438 21.7874 18.3021V22.0383C21.7874 22.0383 21.7874 23.4967 20.3291 23.4967H16.097C16.097 23.4967 14.6387 23.4967 14.6387 22.0383V18.3021C14.6387 18.3021 14.6387 16.8438 16.097 16.8438Z",
    stroke: "#152A58",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4196 24.3892C63.4196 21.1017 62.1136 17.9487 59.7889 15.6241C57.4643 13.2994 54.3113 11.9934 51.0238 11.9934H45.1904",
    stroke: "#152A58",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0238 6.15991L45.1904 11.9932L51.0238 17.8266",
    stroke: "#152A58",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54492 42.6184C6.54492 44.342 6.88441 46.0487 7.544 47.6411C8.2036 49.2335 9.17038 50.6804 10.3891 51.8992C11.6079 53.118 13.0548 54.0847 14.6472 54.7443C16.2396 55.4039 17.9463 55.7434 19.6699 55.7434H24.7741",
    stroke: "#152A58",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9404 61.5766L24.7738 55.7432L18.9404 49.9099",
    stroke: "#152A58",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1074 36.2834C51.2808 41.7959 56.7612 42.1168 61.8828 42.1168",
    stroke: "#152A58",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgBusinessToConsumerPlan;